import useQuery from '@/util/useQuery';
import { useMemo } from 'react';

export interface ChatContext {
  equipmentIds: string[];
  isValid: boolean;
}

export const useChatContext = () => {
  const { query } = useQuery();
  const equipmentIds = useMemo(
    () => (query.selected ? query.selected.split(',') : []),
    [query.selected]
  );
  const isValid = equipmentIds.length === 1;

  return { equipmentIds, isValid };
};
